module.exports = __webpack_public_path__ + "static/media/vol.bd608d41.svg";